export const Role = {
    Admin: 'Administrator',
    HRAdmin: 'HRAdmin',
    Employee: 'Employee',
    HCPM: 'HCPM',
    HTD: 'HTD',
    HCRM: 'HCRM',
    HODR: 'HODR',
    TCRM: 'TCRM',
    TLCM: 'TLCM',
    TLMPR: 'TLMPR',
    TLPM: 'TLPM',
    TLTD: 'TLTD',
    RM: 'RM'
}


// WEBPACK FOOTER //
// ./src/helpers/role.js